var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 1151 1151",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-246.226,-1.33631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.45,576.26C883.45,739.93 751.67,872.61 589.12,872.61C426.57,872.61 294.78,739.93 294.78,576.26C294.78,412.59 426.56,279.9 589.12,279.9C751.68,279.9 883.45,412.59 883.45,576.26",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-246.226,-1.33631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1206.34,576.26C1206.34,730.32 1140.45,855.26 1059.17,855.26C977.89,855.26 912,730.32 912,576.26C912,422.2 977.88,297.26 1059.16,297.26C1140.44,297.26 1206.33,422.16 1206.33,576.26",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-246.226,-1.33631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1338.41,576.26C1338.41,714.26 1315.24,826.2 1286.65,826.2C1258.06,826.2 1234.9,714.29 1234.9,576.26C1234.9,438.23 1258.07,326.32 1286.65,326.32C1315.23,326.32 1338.41,438.22 1338.41,576.26",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-246.226,-1.33631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1633.77,0L1337.48,0L1337.48,0.25L296.29,0.25L296.29,0L-0,0L-0,1150.07L119.51,1150.07L119.51,1150.51L1529.92,1150.51L1529.92,1150.07L1633.77,1150.07L1633.77,0ZM1337.48,296.54L1337.48,854.21L296.29,854.21L296.29,296.54L1337.48,296.54Z",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a450a6cd1088ba7ce22efa4b5d3fad62.svg";
export { ForwardRef as ReactComponent };